"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Generate24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "generate-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M12,1 C15.6585665,1 18.8999678,2.78609689 20.8998057,5.5338926 L21.209435,3.94017818 L22.8782012,4.26455347 L22.12,8.161 L21.981399,8.87820123 L17.3677512,7.98139896 L17.6921265,6.31263274 L19.2062924,6.60593072 C17.5338472,4.37259468 14.8893317,3 12,3 C7.02943725,3 3,7.02943725 3,12 L1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,23 C8.34143347,23 5.10003221,21.2139031 3.10019432,18.4661074 L2.79056498,20.0598218 L1.12179877,19.7354465 L1.88,15.839 L2.01860104,15.1217988 L6.63224881,16.018601 L6.30787351,17.6873673 L4.79370756,17.3940693 C6.46615277,19.6274053 9.1106683,21 12,21 C16.9705627,21 21,16.9705627 21,12 L23,12 L23,12 C23,18.0751322 18.0751322,23 12,23 Z", id: "Mask", fill: "#000000" })));
}
function Generate24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Generate24Svg, Object.assign({}, svgProps)));
}
exports.default = Generate24;
//# sourceMappingURL=Generate24.js.map